<!-- Иконка подтверждения: галочка для успешного действия -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M20 6 9 17l-5-5"
      :stroke="stroke"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "CheckIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
